module.exports = __webpack_public_path__ + "static/media/simplonbp-bold-webfont.d8b3e592.svg";